import { FC } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import { FormData } from '../constants';

type Props = {
	formWatch: FormData;
	control: Control<FormData>;
	setValue: UseFormSetValue<FormData>;
};

const YearlyInput: FC<Props> = ({ formWatch, control, setValue }) => {
	return (
		<>
			{formWatch.recurrenceType === 'YEARLY' ? (
				<Box>
					<Controller
						name="month"
						control={control}
						render={() => (
							<FormControl fullWidth>
								<InputLabel id="month-label">Month</InputLabel>
								<Select
									labelId="month-label"
									id="month"
									value={formWatch.month}
									label="Month"
									onChange={(evt) =>
										setValue('month', evt.target.value ? Number(evt.target.value) : '', {
											shouldValidate: true,
										})
									}
									sx={{ marginBottom: '1rem' }}
								>
									<MenuItem value={1}>January</MenuItem>
									<MenuItem value={2}>Febuary</MenuItem>
									<MenuItem value={3}>March</MenuItem>
									<MenuItem value={4}>April</MenuItem>
									<MenuItem value={5}>May</MenuItem>
									<MenuItem value={6}>June</MenuItem>
									<MenuItem value={7}>July</MenuItem>
									<MenuItem value={8}>August</MenuItem>
									<MenuItem value={9}>September</MenuItem>
									<MenuItem value={10}>October</MenuItem>
									<MenuItem value={11}>November</MenuItem>
									<MenuItem value={12}>December</MenuItem>
								</Select>
							</FormControl>
						)}
					/>
				</Box>
			) : (
				''
			)}
		</>
	);
};

export default YearlyInput;
